"use client"

import styled, { css } from "styled-components"

export const ButtonContainer = styled.div`
  ${({ theme, $secondary = false }) => {
    const { borders } = theme
    const { bg } = theme.colors.secondary
    const { xs, small, large } = theme.spaces

    if ($secondary) {
      return css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: ${small} ${large};
        background-color: ${bg};
        border-radius: ${borders.radius.standard};
      `
    }
    return css`
      padding: ${xs} 0 0 0;
    `
  }}
`

export const ButtonWrapper = styled.div`
  ${({ theme, $flex = false }) => {
    const { small } = theme.spaces
    if ($flex) {
      return css`
        display: flex;
        gap: ${small};
      `
    }
    return css`
      display: flex;
      align-items: center;
      justify-content: space-between;
    `
  }}
`
